var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeOutline = function SvgGlobeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m11.87 2.52-.672 2.693a2.5 2.5 0 0 1-1.816 1.819l-1.376.346c-.318.08-.585.294-.732.586a1.127 1.127 0 0 1-1.683.395L3.124 6.51m8.746-3.99a7.7 7.7 0 0 0-1.871-.228A7.71 7.71 0 0 0 3.124 6.51m8.746-3.99a7.709 7.709 0 1 1-8.746 3.99m6.234 6.691-.556-.834a1.026 1.026 0 0 1 .919-1.592l.55.036c.398.025.781.155 1.112.377l1.044.702a1.244 1.244 0 0 1-.694 2.277h-.571a2.17 2.17 0 0 1-1.804-.966"
  })));
};
export default SvgGlobeOutline;